import CardSystem from '../CardSystem';
import ITask from '../../../Utility/Task/ITask';
import GameObject from '../../../GameObject/GameObject';
import Text from '../../../Prototype/Text';
import Point from '../../../Utility/Point';
import Game from '../../../Game';
import Container from '../../../Prototype/Container';
import AnimationComponent from '../../../Component/Animation';
import { delay } from '../../../Utility/Task/TaskQueue';
import { StartAnimation } from '../../Animation/AnimationHelper';
import { Random } from '../../../Utility/Random';
import { PlaySound } from '../../Audio/AudioHelper';
import ParticleEmitter from '../../../Prototype/Effect/ParticleEmitter';

export default class LevelCompleteTask implements ITask<CardSystem> {
    private fireworksEmitter: ParticleEmitter[] = null;

    public *execute(system: CardSystem): IterableIterator<number> {
        const container = GameObject.Instantiate(Container, {
            relativePosition: new Point(0.5, 0.5),
        });
        if (this.fireworksEmitter === null) {
            this.addFireworksParticleEffects(container);
            PlaySound('fireworks');

            this.fireworksEmitter.forEach((emitter: ParticleEmitter) =>
                setTimeout(emitter.start.bind(emitter), Random.int(0, 1000))
            );
        }

        const textCongratulations = GameObject.Instantiate(Text, {
            text: Game.locale.getText('Congratulations'),
            position: new Point(0, -120),
            scale: new Point(0.2, 0.2),
            anchor: new Point(0.5, 0.5),
            style: Game.style.getStyle('win_sequence.congratulations'),
            alpha: 0,
            bounds: new Point(640, 800),
        });

        const textYouWin = GameObject.Instantiate(Text, {
            text: Game.locale.getText('YouWin'),
            position: new Point(0, 40),
            scale: new Point(0.2, 0.2),
            anchor: new Point(0.5, 0.5),
            style: Game.style.getStyle('win_sequence.you_win'),
            alpha: 0,
            bounds: new Point(1040, 800),
        });

        container.addChild(textCongratulations);
        container.addChild(textYouWin);

        textCongratulations.addComponent(AnimationComponent);
        textYouWin.addComponent(AnimationComponent);

        //system.animator.addChild(container);
        system.scene.addGameObject(container);

        PlaySound('congratulations-text-music');

        StartAnimation(textCongratulations, 'TextPopIn');

        yield* delay(300);

        StartAnimation(textYouWin, 'TextPopIn');

        yield* delay(1300);

        PlaySound('fireworks');
        this.fireworksEmitter.forEach((emitter: ParticleEmitter) =>
            setTimeout(emitter.start.bind(emitter), Random.int(0, 1000))
        );

        yield* delay(1000);

        StartAnimation(textCongratulations, 'AlphaText', {
            startAlpha: 1,
            endAlpha: 0,
            duration: 150,
        });

        yield* delay(50);

        StartAnimation(textYouWin, 'AlphaText', {
            startAlpha: 1,
            endAlpha: 0,
            duration: 150,
        });

        yield* delay(250);
    }

    private addFireworksParticleEffects(container: Container): void {
        this.fireworksEmitter = [];

        const textures: string[] = [];

        for (let i = 1; i <= 16; i++) {
            textures.push(`fireworks_${i}`);
        }

        for (let i = 0; i < 10; i++) {
            const harvestParticleEmitter: ParticleEmitter = GameObject.Instantiate(
                ParticleEmitter,
                {
                    textures,
                    data: Game.resource.get('fireworks'),
                    x: Random.int(-400, 400),
                    y: Random.int(-200, 200),
                }
            );
            this.fireworksEmitter.push(harvestParticleEmitter);
            container.addChild(harvestParticleEmitter);
        }
    }
}
